// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import usePocketbase from '@/composables/usePocketbase'
import { usePocketAuthStore } from '@/stores/usePocketAuthStore'

const routes = [
  { path: '/', redirect: '/info' },
  {
    path: '/:slug',
    name: 'pilot',
    component: () => import('@/views/PocketView.vue'),
    props: true,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0, behavior: 'smooth' }),
})

router.beforeEach(async (to, from, next) => {
  const auth = usePocketAuthStore()
  const pb = usePocketbase()

  // Try auto-login if session is valid but store not hydrated
  if (!auth.user && pb.authStore.isValid) {
    try {
      await auth.tryAutoLogin()
    } catch (e) {
      console.warn('Auto-login failed:', e)
    }
  }

  next()
})

export default router
